<!--
  作者：顾先生
-->
<template>
  <div>
    <div class="wapper xinYongContent">
      <div class="xinYongContent_BoxFlex">
        <title1 title="企业信用公示"></title1>
        <div class="xinYongContent_Box" v-show="isShow">
          <input type="text" v-model="companyName" placeholder="请输入企业全称查询公示情况" class="xinYongContent_input">
          <el-button class="xinYongContent_btn" icon="el-icon-search" @click="chaKan(companyName)">搜索</el-button>
        </div>
      </div>
      <div class="zhengShu" v-show="!isShow && Object.keys(companyInfoS).length > 0">
        <el-button class="zhengShu_btn" type="danger" plain icon="el-icon-arrow-left" @click="Dianji">返回</el-button>
        <div class="zhengShuBoxFlex">
          <div class="zhengShuBox1">
            <div class="zhengShuBox1_p1">承诺单位名称:{{ companyInfoS.zs_company_name }}</div>
            <div class="zhengShuBox1_p2">签署日期:{{ companyInfoS.zs_riqi }}</div>
          </div>
          <div class="zhengShuBox2">
            <img src="../assets/zhengshu/chengnuo_logo1.png" class="zhengShuBox2_logo1">
            <div class="zhengShuBox2_p1">{{ companyInfoS.leixing }}证书</div>
            <img src="../assets/zhengshu/hengxian.png" class="hengxianImg">
            <div class="zhengShuBox2_p2">证书类型：{{ companyInfoS.leixing }}</div>
            <div class="zhengShuBox2_p2">检测平台：鲸诚信-诚信企业计划平台</div>
            <div class="zhengShuBox2_p2">信用机构：{{ companyInfoS.zs_jigou }}</div>
            <div class="zhengShuBox2_p2">证书编号：{{ companyInfoS.zs_zhengshu }}</div>
            <div class="zhengShuBox2_p2">到期日期：{{ companyInfoS.zs_qixian }}</div>
            <img src="../assets/zhengshu/hengxian.png" class="hengxianImg">
            <div class="zhengShuBox2_p3">企业基本信息</div>
            <div class="zhengShuBox2_p2">名<span style="opacity: 0;">书类</span>称：{{ companyInfoS.zs_company_name }}</div>
            <div class="zhengShuBox2_p2">社会信用统一代码：{{ companyInfoS.zs_company_code }}</div>
            <div class="zhengShuBox2_p2">法定代表人：{{ companyInfoS.zs_company_idn }}</div>
            <div class="zhengShuBox2_p2">注册日期：{{ companyInfoS.zs_company_time }}</div>
            <div class="zhengShuBox2_p2">经营场所：{{ companyInfoS.zs_company_address }}</div>
            <div class="zhengShuBox2_p2">经营范围：<span class="zhengShuBox2_p2_fanwei">{{ companyInfoS.zs_company_fanwei
            }}</span></div>
            <div class="zhengShuBox2_Flex">
              <div class="zhengShuBox2_erweima" style="opacity: 0"></div>
              <img src="../assets/zhengshu/zheng1.png" class="zhengShuBox2_Flex_img">
            </div>
          </div>
        </div>
      </div>
      <div class="zhengShu" v-show="!isShow && companyInfoS2.length > 0">
        <el-button class="zhengShu_btn" type="danger" plain icon="el-icon-arrow-left" @click="Dianji">返回</el-button>
        <el-tabs tab-position="left">
          <el-tab-pane key="promise" label="守信承诺书">
            <div class="zhengShuBoxFlex zhengShuBoxFlex2">
              <div class="zhengShuBox1 zhengShuBox1-1">
                <div class="zhengShuBox1_p3">守信承诺书</div>
                <div class="zhengShuBox1_p4">本企业自愿参与信用评价，遵守相关法律法规及GB/T 23794-2023《企业信用评价指标》国家标准，郑重承诺如下：</div>
                <div class="zhengShuBox1_p5">
                  <div>一、主体资质真实：本企业依法设立，信息真实有效，无虚假注册等违规情形；主要管理人员近三年无严重失信记录。</div>
                  <div>二、申报信息真实：提交的评价资料、财务经营数据、资质证照等信息真实、完整，愿意配合信息核验。</div>
                  <div>三、合规诚信经营：遵守各项法律法规，依法纳税、合规用工、诚信履约，无恶意违约、拖欠账款等失信行为。</div>
                  <div>四、接受评价结果：认可评价机构依据国标出具的信用等级及结论，配合必要的信息核查，对合规结果予以尊重。</div>
                  <div>五、承担失信后果：如存在信息造假、虚假申报等失信行为，愿接受撤销等级、公示失信信息等处理，并承担相应责任。</div>
                  <div>六、持续守信自律：不断完善信用管理，自觉接受政府、评价机构及社会监督。</div>
                </div>
                <div class="zhengShuBox1_p1">承诺单位名称:{{ companyInfoS2[0]?.zs_company_name }}</div>
                <div class="zhengShuBox1_p2">签署日期:{{ companyInfoS2[0]?.zs_riqi }}</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane v-for="value in companyInfoS2" :key="value.zs_zhengshu" :label="value.leixing">
            <div class="zhengShuBoxFlex zhengShuBoxFlex2">
              <div class="zhengShuBox2 zhengShuBox2-2">
                <img class="zhengShuBox2_logo2" src="../assets/zhengshu/chengnuo_logo2.png" alt="">
                <div class="zhengShuBox2_p2-2">{{ value.leixing }}证书</div>
                <div class="zhengShuBox2_p2-3">{{ value.ssl_name_eg }}</div>
                <div class="zhengShuBox2_p2-4">证书编号：{{ value.zs_zhengshu }}</div>
                <div class="zhengShuBox2_p2-5">{{ value.zs_company_name }}</div>
                <div class="zhengShuBox2_p2-6">{{ value.ssl_desc }}
                </div>
                <div class="zhengShuBox2_p2-7">{{ value.ssl_name_re }}</div>
                <div class="zhengShuBox2_p2-8">
                  <div class="zhengShuBox2_p2-8-left">
                    <div>颁发日期：{{ value.zs_riqi }}</div>
                    <div>有效日期：{{ value.zs_qixian }}</div>
                    <div>依据标准：{{ value.ssl_gb }}</div>
                    <div>公示查询：https://jingchengxinyong.cn</div>
                  </div>
                  <img class="zhengShuBox2_Flex_img2" src="../assets/zhengshu/zheng2.png" alt="">
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

      </div>
      <div class="xinYongContent_Box2" v-show="isShow">
        <div class="xinYongContent_Box2_p1">诚信企业计划企业公示&nbsp;&nbsp;<span
            style="font-size: 12px; color: #6d6d6d;">(企业信息更新可能会有延迟，如遇错误，请及时联系我们更新)</span></div>
        <div class="xinYongContent_Box2_p2">当前仅随机展示近期加入的企业，如需查询更多，请搜索查询!</div>
        <div class="headerContentBox1_BGc_Box">
          <div class="headerContentBox1_BGc">
            <div class="headerContentBox1">
              <table>
                <thead>
                  <tr>
                    <th>公司名称</th>
                    <th>统一社会信用代码/注册号</th>
                    <th>加入时间</th>
                    <th>到期时间</th>
                    <th>查看详情</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in users" :key="user.id">
                    <td>{{ user.zs_company_name }}<br><span class="pos1">已签署守信承诺书</span><span class="pos2">{{ user.class
                        }}</span></td>
                    <td>{{ user.zs_company_code }}</td>
                    <td>{{ user.zs_riqi }}</td>
                    <td>{{ user.zs_qixian }}</td>
                    <td><el-button type="danger" @click="chaKan(user.zs_company_name, user.zs_class)">查看</el-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="headerContentBox3">当前仅随机展示近期加入工程的企业，如需查询更多，请搜索框查询！</div>
          </div>
        </div>
      </div>
    </div>
    <PublicBottom></PublicBottom>
  </div>
</template>

<script>
import PublicBottom from '@/components/publicBottom.vue'
import title1 from '@/components/title1.vue'
import { chakanCompany, companyInfo } from '@/http/api/user'

export default {
  name: 'xinYongContent',
  // 注册组件
  components: {
    title1,
    PublicBottom
  },
  // 注册方法
  methods: {
    // 记录不用管
    async companyInfo() {
      const { data } = await companyInfo({
        size: 5,
        page: 1
      })
      this.users = data.data
    },
    Dianji() {
      this.isShow = true
    },
    async chaKan(companyName, zsClass) {
      if (companyName.trim() === '') {
        this.searchCompany = ''
        return this.$message.error('请输入公司名称')
      }
      window.scrollTo(0, 300)
      const data = await chakanCompany({
        title: companyName,
        zs_class: zsClass
      })
      if (data.msg === '没有符合条件的数据') {
        return this.$message.error(data.msg)
      }
      this.isShow = false
      if (data.data.length === 1) {
        this.companyInfoS = data.data[0]
        this.companyInfoS2 = []
      } else {
        this.companyInfoS2 = data.data
        this.companyInfoS = {}
      }
    }
  },
  // 父子传值
  props: {},
  // 数据渲染
  data() {
    return {
      companyInfoS: {},
      companyInfoS2: [],
      companyName: '',
      isShow: true,
      users: []
    }
  },
  // 计算属性
  computed: {},
  // 监听器
  watch: {},
  // 页面初次解析完成
  created() {
    this.companyInfo()
  },
  // 页面内容渲染完成
  mounted() { }
}
</script>

<style scoped lang="less">
/deep/ .el-tabs__item.is-active {
  color: #F56C6C;
}

/deep/ .el-tabs--left .el-tabs__active-bar {
  background-color: #F56C6C;
}
.zhengShu {
  position: relative;
  margin: 40px 0 40px 0;
  padding: 30px 0 0 0;
  min-height: 700px;

  .zhengShu_btn {
    position: absolute;
    right: 30px;
    top: -60px;
  }

  .zhengShuBoxFlex {
      padding: 10px;
      display: flex;

      .zhengShuBox1 {
        position: relative;
        width: 650px;
        height: 390px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        border-radius: 10px;
        background-image: url("../assets/zhengshu/zhengshu.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;

        .zhengShuBox1_img {
          position: absolute;
          width: 200px;
          bottom: 35px;
          left: 20px;
        }

        .zhengShuBox1_p3 {
          position: absolute;
          font-size: 19px;
          left: 50%;
          transform: translateX(-50%);
          top: 61.5px;
          letter-spacing: 4px;
          margin-left: 8px;
          color: #846647;
        }

        .zhengShuBox1_p1,
        .zhengShuBox1_p2 {
          position: absolute;
          font-size: 12px;
          color: #696968;
        }

        .zhengShuBox1_p1,
        .zhengShuBox1_p2 {
          left: 50px;
        }

        .zhengShuBox1_p1 {
          bottom: 80px;
        }

        .zhengShuBox1_p2 {
          bottom: 60px;
        }

        .zhengShuBox1_p4,
        .zhengShuBox1_p5 {
          width: 450px;
          margin: 0 auto;
          text-align: justify;
          line-height: 20px;
          letter-spacing: 1px;
        }

        .zhengShuBox1_p4 {
          font-size: 12px;
          margin-top: 120px;
          font-weight: bold;
          text-indent: 2em;
          margin-bottom: 20px;
        }

        .zhengShuBox1_p5 {
          text-indent: 2em;
          font-size: 12px;

          div {
            margin-bottom: 10px;
          }
        }
      }

      .zhengShuBox1-1 {
        background-image: url("../assets/zhengshu/zhengshu2.png");
        height: 620px;
        font-family: 'Noto serif SC', serif;
        font-weight: bold;
        width: 600px;

        .zhengShuBox1_p1,
        .zhengShuBox1_p2 {
          text-align: right;
          width: 450px;
          margin: 0 auto;
          color: #000000;
          left: 80px;
        }
      }

      .zhengShuBox2 {
        text-align: justify;
        position: relative;
        padding-bottom: 70px;
        margin-left: 30px;
        width: 700px;
        background-image: url("../assets/zhengshu/chengnuoshu.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;

        .zhengShuBox2_logo1 {
          display: block;
          margin: 80px auto 0;
          width: 172px;
        }

        .hengxianImg {
          display: block;
          width: 170px;
          margin: 22px auto 8px;
        }

        .zhengShuBox2_p1 {
          font-size: 40px;
          letter-spacing: 3px;
          margin-top: 20px;
          font-weight: bolder;
          text-align: center;
          color: #cf413a;
        }

        .zhengShuBox2_p2 {
          width: 430px;
          margin-top: 10px;
          font-size: 14px;
          margin-left: 85px;
        }

        .zhengShuBox2_p2_fanwei {
          font-size: 12px;
        }

        .zhengShuBox2_Flex {
          display: flex;
          align-items: center;

          .zhengShuBox2_erweima {
            margin-left: 85px;
            margin-right: 20px;
            margin-top: 20px;
            width: 90px;
            height: 90px;
            background-color: #4a4949;
          }

          .zhengShuBox2_Flex1,
          .zhengShuBox2_Flex2 {
            margin-top: 30px;
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }

          .zhengShuBox2_Flex_img {
            height: 90px;
            margin-left: 30px;
          }
        }

        .zhengShuBox2_p3 {
          font-size: 18px;
          letter-spacing: 2px;
          margin-top: 20px;
          font-weight: 900;
          text-align: center;
          color: #cf413a;
        }
      }

      /deep/.el-tabs__item.is-active {
        color: red;
      }

      .zhengShuBox2-2 {
        text-align: justify;
        position: relative;
        padding-bottom: 70px;
        margin-left: 30px;
        width: 600px;
        background-image: url("../assets/zhengshu/chengnuoshu2.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;

        .zhengShuBox2_logo2 {
          width: 108px;
          height: 108px;
          margin: 48px auto 0;
          display: block;
        }

        .zhengShuBox2_p2-2 {
          font-family: 'Noto serif SC', serif;
          font-weight: bolder;
          font-size: 46px;
          color: #000000;
          text-align: center;
          letter-spacing: 4px;
          line-height: 1;
          margin-top: 30px;
        }

        .zhengShuBox2_p2-3 {
          font-family: 'Noto serif SC', serif;
          // font-weight: bold;
          font-size: 17px;
          color: #000000;
          text-align: center;
          line-height: 1;
          margin-top: 17px;
          letter-spacing: 2px;
        }

        .zhengShuBox2_p2-4 {
          font-family: 'Noto serif SC', serif;
          font-size: 14px;
          color: #000000;
          text-align: center;
          line-height: 1;
          margin-top: 15px;
          letter-spacing: 1px;
        }

        .zhengShuBox2_p2-5 {
          font-family: 'Noto Sans SC', serif;
          font-weight: 400;
          font-size: 28px;
          color: #DE0000;
          text-align: center;
          line-height: 1;
          margin-top: 32px;
        }

        .zhengShuBox2_p2-6 {
          font-family: 'Noto Sans SC', serif;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          width: 390px;
          margin: 26px auto 0;
          line-height: 32px;
          letter-spacing: 1px;
          height: 96px;
        }

        .zhengShuBox2_p2-7 {
          font-family: 'Noto serif SC', serif;
          font-weight: bold;
          font-size: 48px;
          color: #DC0000;
          text-align: center;
          line-height: 1;
          margin-top: 25px;
          letter-spacing: 5px;
        }

        .zhengShuBox2_p2-8 {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 20px;
          margin-top: 70px;

          .zhengShuBox2_p2-8-left {
            font-family: 'Noto Sans SC', serif;
            font-weight: 400;
            font-size: 13px;
            color: #333333;
            line-height: 24px;
            // width: 390px;
            letter-spacing: 1px;
          }

          .zhengShuBox2_Flex_img2 {
            height: 90px;
            // margin-left: 30px;
          }
        }
      }
    }
}

.xinYongContent {
  margin: 0 auto;

  .xinYongContent_BoxFlex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .xinYongContent_Box {
    margin-top: 20px;
    margin-right: 20px;
    float: right;
    width: 350px;
    height: 40px;
    border: 2px solid #e23743;
    border-radius: 8px;
    background-color: #fff;
    display: flex;
    align-items: center;

    .xinYongContent_input {
      margin-left: 10px;
      width: 270px;
      height: 30px;
      font-size: 14px;
      border: none;
    }

    .xinYongContent_btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 30px;
      color: white;
      font-size: 12px;
      background-color: #dd1216;
    }
  }

  .xinYongContent_Box2 {
    padding: 20px;
    margin-top: 30px;
    border-radius: 8px;
    border: 2px solid #e23743;

    .xinYongContent_Box2_p1 {
      font-size: 18px;
      color: #000000;
      font-weight: bold;
    }

    .xinYongContent_Box2_p2 {
      margin-top: 10px;
      font-size: 13px;
      color: #515151;
    }

    .headerContentBox1_BGc_Box {
      position: relative;
      margin-top: 30px;

      .headerContentBox1_BGc {
        margin-top: 20px;
      }

      .headerContentBox3 {
        margin-top: 20px;
        text-align: center;
        font-size: 13px;
        color: #000000;
        opacity: 0.61;
      }

      .headerContentBox1 {
        background-color: #fff;

        th {
          padding: 15px;
          font-size: 18px;
          color: #7a7a7a;
        }

        tbody {

          .pos1,
          .pos2 {
            display: inline-block;
            margin-top: 10px;
            transform: scale(.9);
            padding: 2px 5px;
            text-align: center;
            font-size: 12px;
          }

          .pos1 {
            color: #0084ff;
            border: solid 1px #0084ff;
          }

          .pos2 {
            border: solid 1px #e73d4a;
            color: #e73d4a;
          }

          tr:nth-child(2n-1) {
            background-color: #fff3f3;
          }
        }

        td {
          padding: 20px;
          font-size: 15px;
          color: #7a7a7a;
        }

        table {
          border-collapse: collapse;
          border: 0;
          text-align: center;
          width: 100%;
        }
      }
    }
  }
}
</style>
